import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useRef, useState } from 'react';
import { fetchAllNoticesByAdmin } from '../../redux/actions/noticeActions';
import NoticeDetails from '../../components/notices/NoticeDetails';

const Notices = () => {
  const dispatch = useDispatch();
  const { notices = [], meta, loading, error } = useSelector((state) => state.notices || {});

  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [noticeType, setNoticeType] = useState('');
  const noticeTypeOptions = ['N4', 'RTB-30', ];

  const [selectedNotice, setSelectedNotice] = useState(null);
  const [showDetails, setShowDetails] = useState(false);

  const debounceRef = useRef();

  // const triggerFetch = (overrides = {}) => {
  //   dispatch(
  //     fetchAllNoticesByAdmin({
  //       page,
  //       limit: 10,
  //       q: overrides.search ?? search,
  //       notice_type: overrides.noticeType ?? noticeType
  //     })
  //   );
  // };

  const triggerFetch = (overrides = {}) => {
    dispatch(
      fetchAllNoticesByAdmin({
        page: overrides.page ?? page,
        limit: 10,
        q: overrides.search ?? search,
        notice_type: overrides.noticeType ?? noticeType
      })
    );
  };

  useEffect(() => {
    triggerFetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page,noticeType]);

  const onSearchChange = (e) => {
    const value = e.target.value;
    setSearch(value);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    // debounceRef.current = setTimeout(() => {
    //   setPage(1);
    //   triggerFetch({ search: value });
    // }, 300);
    debounceRef.current = setTimeout(() => {
      setPage(1);
      triggerFetch({ search: value, page: 1 }); 
    }, 300);
  };

  const onStatusChange = (e) => {
    const value = e.target.value;
    setNoticeType(value);
    setPage(1);
    triggerFetch({ noticeType: value });
  };

  const openDetails = (notice) => {
    setSelectedNotice(notice);
    setShowDetails(true);
  };

  const closeDetails = () => {
    setSelectedNotice(null);
    setShowDetails(false);
  };

  const formatDate = (value) => {
    if (!value) return '-';
    const d = new Date(value);
    return isNaN(d.getTime()) ? '-' : d.toLocaleDateString();
  };

  return (
    <div className="container py-3">
      <h2 className="mb-3">Notices</h2>

      <div className="row g-2 mb-3">
        <div className="col-md-4">
          <input
            type="text"
            className="form-control"
            placeholder="Search by property, lease, landlord, type"
            value={search}
            onChange={onSearchChange}
          />
        </div>
        <div className="col-md-3">
          <select className="form-select" value={noticeType} onChange={onStatusChange}>
            <option value="">All Notice Types</option>
            {noticeTypeOptions.map((opt) => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </select>
        </div>
      </div>

      {/* {loading && <div>Loading...</div>} */}

      <div className="table-responsive">
        <table className="table table-striped table-hover align-middle">
          <thead className="table-primary">
            <tr>
              <th>Notice Type</th>
              <th>Property</th>
              <th>Lease</th>
              <th>Landlord</th>
              <th>Unit</th>
              <th>Province</th>
              <th>Issued</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
             {loading && (
              <tr>
                <td colSpan="8" className="text-center">
                  Loading...
                </td>
              </tr>
            )}
            {!loading && notices.map((n) => (
              <tr key={n.id}>
                <td>{n.notice_type}</td>
                <td>{n.lease?.property?.property_name || '-'}</td>
                <td>{n.lease?.lease_name || '-'}</td>
                <td>{n.landlord ? `${n.landlord.first_name} ${n.landlord.last_name}` : '-'}</td>
                <td>{n.lease?.unit?.unit || '-'}</td>
                <td>{n.province_code || n.lease?.property?.province?.code || '-'}</td>
                <td>{formatDate(n.createdAt)}</td>
                <td>
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={() => openDetails(n)}
                  >
                    View
                  </button>
                </td>
              </tr>
            ))}
            {!loading && notices.length === 0 && (
              <tr>
                <td colSpan="8" className="text-center py-4">No notices found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {meta?.totalPages > 1 && (
        <div className="d-flex justify-content-center gap-2 mt-3">
          <button
            className="btn btn-outline-primary btn-sm"
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            Prev
          </button>
          <span className="align-self-center">Page {page} of {meta.totalPages}</span>
          <button
            className="btn btn-outline-primary btn-sm"
            disabled={page === meta.totalPages}
            onClick={() => setPage(page + 1)}
          >
            Next
          </button>
        </div>
      )}

      {showDetails && selectedNotice && (
        <NoticeDetails notice={selectedNotice} onClose={closeDetails} />
      )}
    </div>
  );
};

export default Notices;
